import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@pipebase/ui';
import { App } from './App';
import { migrateLocalStorage } from './bootstrap/migrateLocalStorage';
import './monacoLoader';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';
// Inter and JetBrains Mono from the bundle, not Google Fonts: no request to
// a third party, and the CSP needs no font origin (designer 0.7.42).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './styles.css';
import './help/help.css';

// Carry user settings (workspace name, categories, panel widths, etc.)
// across the iPaaS → Pipebase rebrand. Idempotent; safe on every boot.
migrateLocalStorage();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
